import React from "react";
import ActivateAccountAdmin from "../../components/activateAccount/ActivateAccountAdmin";

const ActivateAccountAdminPage = () => {
	return (
		<>
			<ActivateAccountAdmin />
		</>
	);
};

export default ActivateAccountAdminPage;
